/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useParams } from 'react-router-dom';
import {
  Grid,
  Stack,
} from '@mui/material';

import { Container } from '@mui/system';

import {
  doc,
  getDoc,
} from 'firebase/firestore';


import { PDFDownloadLink } from '@react-pdf/renderer';
import { useRef } from 'react';
import { db } from '../../firebase.config';

import { UserAuth } from '../../context/AuthContext';
import Page from '../../components/Page';
import QRCodeGenerator from '../../components/QRCodeGenerator';
import CustomButton from '../../components/CustomButton';
import { useSnackbar } from '../../context/snackbarContext';
import CustomModal from '../../components/customModal/customModal';
import CttDoorDoc from '../../components/pdf/cttDoorDoc';

// eslint-disable-next-line no-var
var QRCode = require('qrcode');

const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'white',
  border: '1px solid white',
  borderRadius: '7px',
  boxShadow: 0,
  p: 3,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingX: 1, paddingY: 5, minHeight: 400 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const params = useParams;

// ----------------------------------------------------------------------

export default function CttDoor() {
  const { user } = UserAuth();
  const [refresh, setRefresh] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [opMobile, setOpMobile] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const showSnackbar = useSnackbar()
  const [qrcode, setQr] = React.useState('');

  const [idOrg, setIdOrg] = React.useState();
  // loading
  const [qrCodeValue, setQrCodeValue] = React.useState('');

  const handleCopy = () => {
    navigator.clipboard.writeText(qrCodeValue)
    showSnackbar('Lien copié dans le presse-papie', false)

  };

  const downloadSelectedTicket = async () => {
    setOpen(true)
    try {
      QRCode.toDataURL(
        qrCodeValue,
        {
          width: 130,
          margin: 1,
          errorCorrectionLevel: 'H',
          color: {
            dark: '#000000',
            light: '#ffffff',
          },
        },
        (err, url) => {
          if (err) return console.log('erreur : ', err);
          setQr(url);
        }
      );
      setTimeout(() => {
        downloadLinkRef.current.click();
      }, 1000); // délai d'une seconde pour garantir le rendu
    } catch (error) {
      console.log(error);
    }
    // handleCloseMenuDetail();
    // handleOpenTicketModal();
    // handleCloseDownloadModal();
  };
  const downloadLinkRef = useRef(null);


  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const docRef0 = doc(db, 'organisateurs', user.uid);
        const docSnap = await getDoc(docRef0);
        setIdOrg(docSnap.data().idOrg);
        setQrCodeValue(`choptonticket.com/fr/organisateur/${docSnap.data().idOrg}`)
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    })();
  }, [user.uid]);

  // qr code
  return (
    <Page title="CTT Door">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            CTT Door
            <br />
            <Typography variant="body2">
              Xpress Door simplifie la vente de billets à l’entrée de vos évènements
            </Typography>
          </Typography>
        </Stack>
        <Box
          sx={{
            height: '100%',
            borderRadius: '7px',
            padding: 3,
            border: '2px solid gainsboro'
          }}
        >
          <Grid container spacing={2} alignItems='center'>
            <Grid item>
              <QRCodeGenerator value={qrCodeValue} />
            </Grid>
            <Grid item>
              <Typography variant='h6' textAlign="Start">
                <strong>Votre QR code CTT Door</strong>
              </Typography>
              <Typography variant="body2" textAlign="Start">
                Imprimez ce code QR et affichez-le en évidence pour fluidifier l'achat de billets à l'entrée.
              </Typography>
              <Stack paddingY={2} direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <CustomButton onClick={handleCopy} type={'primaire'} buttonText={'Copier votre lien'} />
                <CustomButton onClick={downloadSelectedTicket} type={'primaire'} buttonText={'Telecharger votre QR code'} />
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <CustomModal open={open} showConfirm={false} onClose={() => setOpen(false)} cancelText='Fermer'>
        <Typography  textAlign={'center'} variant="body2">
          Si le telechargment ne demare pas automatiquement, cliquez{' '}
          <PDFDownloadLink
            document={<CttDoorDoc link={qrcode} />}
            fileName={'cttDoor.pdf'}
          >
            {({ blob, url, loading, error }) => {
              console.log('erreur : ', error);
              return loading ? 'Genration du ticket......' : 'ici';
            }}
          </PDFDownloadLink>{' '}
          <PDFDownloadLink
            document={<CttDoorDoc link={qrcode} />}
            fileName={'cttDoor.pdf'}
          >
            {({ loading }) => (
              <button ref={downloadLinkRef} style={{ display: 'none' }}>
                {loading ? 'Chargement du document...' : 'ici'}
              </button>
            )}
          </PDFDownloadLink>{" "}
          pour Telecharger votre Qrcode
        </Typography>
      </CustomModal>
    </Page>
  );
}
